/**
 * User status
 */

/**
 * The user has been blocked, temporary if block until is not null or permanent if it is null
 */
export const USER_STATUS_BLOCKED = 'blocked'

/**
 * The user is active
 */
export const USER_STATUS_ACTIVE = 'active'

/**
 * Get all of the valid status for a user
 */
export function getAllValidStatus () {
  return [USER_STATUS_BLOCKED, USER_STATUS_ACTIVE]
}
